import React from 'react';

import styled from '@emotion/styled';

interface IDividerWithText {
  children: React.ReactNode;
}

const DividerWithText: React.FC<IDividerWithText> = ({ children }) => {
  return <DividerWithTextWrapper>{children}</DividerWithTextWrapper>;
};

export default DividerWithText;

const DividerWithTextWrapper = styled.div`
  display: flex;
  flex-direction: row;
  color: ${({ theme }) => theme.palette.lightGrayText};
  font-size: 12px;
  font-weight: 500;

  &:before,
  &:after {
    content: '';
    flex: 1 1;
    border-bottom: 1px solid ${({ theme }) => theme.palette.borderColor};
    margin: auto;
    width: 80px;
  }
  &:before {
    margin-right: 2px;
  }
  &:after {
    margin-left: 2px;
  }
`;
